/******/ (() => { // webpackBootstrap
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  var free_gift = document.querySelectorAll('.free-gift-product');
  if (typeof free_gift != 'undefined' && free_gift != null) {
    free_gift.forEach(function (product) {
      var variants = product.querySelectorAll('.variant-button input'),
        input_id = product.querySelector('[name="id"]'),
        add_to_cart = product.querySelector('.product__submit__add');
      variants.forEach(function (variant) {
        variant.addEventListener('click', function () {
          var variant_ID = variant.getAttribute('id'),
            available = variant.getAttribute('data-available');
          input_id.value = variant_ID;
          if (available == 'true') {
            add_to_cart.disabled = false;
            add_to_cart.innerHTML = window.theme.strings.upsellAddToCart;
          } else {
            add_to_cart.disabled = true;
            add_to_cart.innerHTML = window.theme.strings.soldOut;
          }
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    var infoWrapper = document.querySelectorAll('.product__slide .model-info-wrapper');
    infoWrapper.forEach(function (wrapper) {
      var infoButton = wrapper.querySelector('.model-info-btn');
      var closeButton = wrapper.querySelector('.js-close-info');
      var infoContent = wrapper.querySelector('.model-info-content');
      var sizeGuideButton = wrapper.querySelector('.js-model-size-guide-button');
      var sizeGuideModal = document.querySelector('.js-size-guide-modal');
      infoButton === null || infoButton === void 0 || infoButton.addEventListener('click', function () {
        infoContent === null || infoContent === void 0 || infoContent.classList.add('active');
        infoButton === null || infoButton === void 0 || infoButton.classList.add('active');
      });
      closeButton === null || closeButton === void 0 || closeButton.addEventListener('click', function () {
        infoContent === null || infoContent === void 0 || infoContent.classList.remove('active');
        infoButton === null || infoButton === void 0 || infoButton.classList.remove('active');
      });
      sizeGuideButton === null || sizeGuideButton === void 0 || sizeGuideButton.addEventListener('click', function () {
        sizeGuideModal.style.opacity = '1';
        sizeGuideModal.style.display = 'block';
      });
    });
  });

  // RF: Loyalty page section fade
  window.addEventListener('load', function () {
    var isLoyaltyPage = document.querySelector('.loyalty-page');
    if (!!isLoyaltyPage) {
      var sections = document.querySelectorAll('.loyalty-page__section, #shopify-section-footer');
      sections.forEach(function (section) {
        return section.classList.add('is-blurred');
      });
      var getActiveSection = function getActiveSection() {
        var screenCenter = window.scrollY + window.innerHeight / 2;
        sections.forEach(function (section) {
          var sectionTop = section.getBoundingClientRect().top + window.scrollY;
          var sectionBottom = section.getBoundingClientRect().bottom + window.scrollY;
          var active = screenCenter > sectionTop && screenCenter < sectionBottom;
          section.classList.toggle('is-active', active);
        });
      };

      // RF: Get active section on scroll (debounced)
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            getActiveSection();
            ticking = false;
          });
          ticking = true;
        }
      });

      // RF: Get active section on load
      getActiveSection();
    }
  });
})();

// Function which helps run JS in customizer and see the result instantly (without page reload/save)
var onShopifySectionLoad = function onShopifySectionLoad(run) {
  document.addEventListener('shopify:section:load', function () {
    return run('shopify:section:load');
  });
};

// Hotspots-Tooltips functionality for hotspots-tooltip.liquid
var initHotspotsTooltips = function initHotspotsTooltips() {
  var hotspots = document.querySelectorAll('[data-hotspot-trigger]');
  if (hotspots.length === 0) return;
  var closeHotspots = function closeHotspots() {
    hotspots.forEach(function (el) {
      el.classList.remove('hotspots-tooltips__hotspot--active');
      var content = el.querySelector('[data-hotspot-content]');
      if (content) {
        content.classList.add('hide');
      }
    });
  };
  hotspots.forEach(function (hotspot) {
    hotspot.addEventListener('click', function (event) {
      var isActive = hotspot.classList.contains('hotspots-tooltips__hotspot--active');
      var hotspotPopup = hotspot.querySelector('[data-hotspot-content]');
      event.stopPropagation();
      closeHotspots();
      if (!isActive) {
        hotspot.classList.add('hotspots-tooltips__hotspot--active');
        if (hotspotPopup) {
          hotspotPopup.classList.remove('hide');
        }
      }
      window.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape') {
          closeHotspots();
        }
      });
      setTimeout(function () {
        window.addEventListener('click', function (evt) {
          if (evt.target !== hotspot && !hotspot.contains(evt.target)) {
            closeHotspots();
          }
        }, {
          once: true
        });
      }, 100);
    });
  });
};
initHotspotsTooltips();

// Splide (autoscroll slide) functionality for carousel.liquid
var initCarouselSectionSliders = function initCarouselSectionSliders() {
  var carouselSlidersTop = document.querySelectorAll('[data-carousel-slider-top]');
  var carouselSlidersBottom = document.querySelectorAll('[data-carousel-slider-bottom]');
  if (carouselSlidersTop.length) {
    carouselSlidersTop.forEach(function (slider) {
      var splideTopInstance = new Splide(slider, {
        type: 'loop',
        drag: 'free',
        direction: 'rtl',
        arrows: false,
        pagination: false,
        perPage: 5,
        gap: 29,
        breakpoints: {
          989: {
            perPage: 4,
            gap: 6
          },
          749: {
            perPage: 3
          }
        },
        autoScroll: {
          speed: 0.5
        }
      });
      splideTopInstance.mount(window.splide.Extensions);
    });
  }
  if (carouselSlidersBottom.length) {
    carouselSlidersBottom.forEach(function (slider) {
      var splideBottomInstance = new Splide(slider, {
        type: 'loop',
        drag: 'free',
        arrows: false,
        pagination: false,
        perPage: 5,
        gap: 29,
        breakpoints: {
          989: {
            perPage: 4,
            gap: 6
          },
          749: {
            perPage: 3
          }
        },
        autoScroll: {
          speed: 0.5
        }
      });
      splideBottomInstance.mount(window.splide.Extensions);
    });
  }
};
initCarouselSectionSliders();
var initSnapPage = function initSnapPage() {
  var snapPageElement = document.querySelector('[data-snap-page]');
  if (snapPageElement) {
    var wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('swiper-wrapper');
    var sectionTitles = [];
    while (snapPageElement.firstChild) {
      var child = snapPageElement.firstChild;
      if (child.nodeType === Node.ELEMENT_NODE) {
        child.classList.add('swiper-slide');
        var titleElement = child.querySelector('h2');
        if (titleElement) {
          titleElement.style.textTransform = 'none';
          sectionTitles.push(titleElement.innerText);
        }
        wrapperDiv.appendChild(child);
      } else {
        wrapperDiv.appendChild(child);
      }
    }
    snapPageElement.appendChild(wrapperDiv);
    if (sectionTitles.length > 0) {
      var navigationDiv = document.createElement('div');
      navigationDiv.classList.add('snap-navigation');
      var navInner = document.createElement('div');
      navInner.setAttribute('snap-navigation-inner', '');
      navInner.classList.add('snap-navigation-inner');
      sectionTitles.forEach(function (title, index) {
        var navItem = document.createElement('div');
        navItem.classList.add('snap-navigation-item');
        navItem.setAttribute('data-snap-navigation-item', index);
        var navText = document.createElement('span');
        navText.classList.add('snap-navigation-text');
        navText.innerText = title;
        navItem.appendChild(navText);
        navInner.appendChild(navItem);
      });
      navigationDiv.appendChild(navInner);
      snapPageElement.appendChild(navigationDiv);
    }
    var snapPage = new Swiper('[data-snap-page]', {
      direction: "vertical",
      slidesPerView: 1,
      mousewheel: {
        releaseOnEdges: true,
        thresholdDelta: 35
      },
      touchReleaseOnEdges: true,
      autoHeight: true,
      effect: 'fade',
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
      fadeEffect: {
        crossFade: true
      }
    });
    var handleNoSwiping = function handleNoSwiping() {
      snapPage.slides.forEach(function (slide) {
        return slide.classList.toggle('swiper-no-swiping', window.innerWidth > 990);
      });
    };
    handleNoSwiping();
    window.addEventListener('resize', handleNoSwiping);
    var snapNavigationItems = document.querySelectorAll('[data-snap-navigation-item]');
    snapNavigationItems.forEach(function (navItem, index) {
      navItem.addEventListener('click', function (evt) {
        evt.preventDefault();
        snapPage.slideTo(navItem.dataset.snapNavigationItem);
      });
      index === 0 ? navItem.classList.add('snap-navigation-item--active') : null;
    });
    var snapNavigationInner = document.querySelector('[snap-navigation-inner]');
    snapPage.on('slideChange', function () {
      var activeSlide = snapPage.slides[snapPage.activeIndex];
      var hasTooltipsSection = activeSlide.querySelector('[data-hotspots-tooltips-section]');
      var hasTimelineSection = activeSlide.querySelector('[data-timeline-section]');
      var hasCtaBannersSection = activeSlide.querySelector('[data-cta-banners]');
      var isLastSlide = snapPage.activeIndex === snapPage.slides.length - 1;
      snapNavigationInner.classList.remove('snap-navigation-inner--tooltips', 'snap-navigation-inner--timeline');
      snapNavigationItems.forEach(function (navItem) {
        return navItem.dataset.snapNavigationItem == snapPage.activeIndex ? navItem.classList.add('snap-navigation-item--active') : navItem.classList.remove('snap-navigation-item--active');
      });
      if (hasTimelineSection || hasCtaBannersSection) {
        snapNavigationInner.classList.add('snap-navigation-inner--timeline');
        snapNavigationInner.scroll(999, 0);
      } else if (hasTooltipsSection) {
        snapNavigationInner.classList.add('snap-navigation-inner--tooltips');
      }
      if (isLastSlide) {
        setTimeout(function () {
          document.body.style.overflow = 'initial';
        }, 1000);
      }
    });
    document.body.addEventListener('wheel', function (event) {
      if (event.deltaY < 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
  }
};
initSnapPage();
var initTimelineSnap = function initTimelineSnap() {
  var timelineSection = document.querySelector('[data-timeline-section]');
  if (timelineSection) {
    var timelineSlider = new Swiper(timelineSection, {
      direction: "vertical",
      slidesPerView: 1,
      mousewheel: {
        thresholdDelta: 50
      },
      nested: true,
      autoHeight: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      breakpoints: {
        990: {
          noSwiping: true,
          noSwipingClass: 'swiper-no-swiping'
        }
      }
    });
    var timelineNavItems = timelineSection.querySelectorAll('[data-navigation-item]');
    timelineNavItems.forEach(function (navItem) {
      navItem.addEventListener('click', function (evt) {
        evt.preventDefault();
        timelineSlider.slideTo(navItem.dataset.navigationItem);
      });
    });
    var parentSlider = document.querySelector('[data-snap-page]').swiper;
    timelineSlider.on('slideChange', function () {
      timelineNavItems.forEach(function (navItem) {
        return navItem.dataset.navigationItem == timelineSlider.activeIndex ? navItem.classList.add('active-nav') : navItem.classList.remove('active-nav');
      });
      var isLastSlide = timelineSlider.activeIndex === timelineSlider.slides.length - 1;
      if (isLastSlide) {
        parentSlider.disable();
        document.body.style.overflow = 'hidden';
        setTimeout(function () {
          parentSlider.enable();
        }, 500);
      } else {
        document.body.style.overflow = 'initial';
      }
    });
  }
};
initTimelineSnap();

// Lookbook V2
var initLookbookV2 = function initLookbookV2() {
  var toggle = document.querySelector('[data-lookbook-choice-toggle]');
  var choiceMenu = document.querySelector('[data-lookbook-choice-menu]');
  var styleChoices = document.querySelectorAll('[data-lookbook-style]');
  var viewChoices = document.querySelectorAll('[data-lookbook-view]');
  var body = document.querySelector('body');
  var products = document.querySelectorAll('[data-lookbook-product]');
  var modals = document.querySelectorAll('.lookbook-product-slide');
  var readMore = document.querySelector('.lookbook--read-more');
  var closeReadMore = document.querySelector('#closeLookbookIntro');
  var lookBookGrid = document.querySelector('.lookbook-v2-grid');
  var mobileIntro = document.querySelector('.lookbook-v2--inner-intro');
  var fullCollection = document.querySelector('.lookbook-v2--full-collection');
  var currentScroll = 0;
  if (readMore) {
    readMore.addEventListener('click', function (e) {
      e.preventDefault();
      lookBookGrid.classList.add('lookbook-v2-grid--show-intro');
      if (mobileIntro != null) {
        window.scrollTo({
          behavior: 'smooth',
          top: mobileIntro.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 100
        });
      }
    });
  }
  if (closeReadMore) {
    closeReadMore.addEventListener('click', function (e) {
      e.preventDefault();
      lookBookGrid.classList.remove('lookbook-v2-grid--show-intro');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
  if (toggle !== null) {
    window.addEventListener('click', function (e) {
      toggle.classList.remove('lookbook-choice-toggle--active');
      choiceMenu.classList.remove('lookbook-choices__menu--active');
    });
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      toggle.classList.toggle('lookbook-choice-toggle--active');
      choiceMenu.classList.toggle('lookbook-choices__menu--active');
    });
  }
  if (styleChoices.length) {
    styleChoices.forEach(function (style) {
      style.addEventListener('click', function (e) {
        document.querySelector('.lookbook-style.lookbook-choice--active').classList.remove('lookbook-choice--active');
        style.classList.add('lookbook-choice--active');
        body.classList.remove('lookbook--studio', 'lookbook--location');
        body.classList.add("lookbook--".concat(style.dataset.lookbookStyle));
      });
    });
  }
  if (viewChoices.length) {
    viewChoices.forEach(function (view) {
      view.addEventListener('click', function (e) {
        document.querySelector('[data-lookbook-view].active').classList.remove('active');
        view.classList.add('active');
        body.classList.remove('lookbook-view--standard', 'lookbook-view--six');
        body.classList.add("lookbook-view--".concat(view.dataset.lookbookView));
      });
    });
  }
  if (products.length) {
    products.forEach(function (product) {
      product.addEventListener('click', function (e) {
        e.preventDefault();
        var activeModal = document.querySelector('.lookbook-product-slide.active');
        if (activeModal !== null) {
          activeModal.classList.remove('active');
        }
        currentScroll = window.scrollY;
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        document.querySelector('.collection-wrapper').classList.remove('hide');
        document.querySelector(".lookbook-product-slide[data-slide=\"".concat(product.dataset.lookbookProduct, "\"]")).classList.add('active');
        document.querySelector('.lookbook-v2-grid').classList.add('hidden');
        fullCollection.classList.add('hide');
        var carousels = document.querySelectorAll('.lookbook-product-slide[data-slide="' + product.dataset.lookbookProduct + '"] .lookbook-carousel');
        function initializeFlickity(carousel) {
          var flickityItems = carousel.getAttribute('data-flickity-items');
          if (!carousel.classList.contains('flickity-enabled')) {
            var parsedOptions = {};
            if (flickityItems) {
              try {
                parsedOptions = JSON.parse(flickityItems);
              } catch (error) {
                console.error('Error parsing Flickity options:', error);
              }
            }
            new Flickity(carousel, parsedOptions);
          }
        }

        // Initialize Flickity only after images are loaded
        carousels.forEach(function (carousel) {
          if (typeof imagesLoaded === 'function') {
            imagesLoaded(carousel, function () {
              initializeFlickity(carousel);
              // After Flickity is initialized, listen for lazyloaded events
              carousel.addEventListener('lazyloaded', function () {
                if (carousel.flickityInstance) {
                  carousel.flickityInstance.resize();
                }
              });
            });
          } else {
            // Fallback: initialize immediately if imagesLoaded is not available
            initializeFlickity(carousel);
          }
        });

        // Reinitialize Flickity on window resize
        window.addEventListener('resize', function () {
          carousels.forEach(function (carousel) {
            // Destroy existing Flickity instance if it exists
            if (carousel.flickityInstance) {
              carousel.flickityInstance.destroy();
            }

            // Reinitialize Flickity
            initializeFlickity(carousel);
          });
        });
      });
    });
    document.querySelectorAll('.lookbook-back').forEach(function (lookBack) {
      lookBack.addEventListener('click', function (e) {
        e.preventDefault();
        var activeModal = document.querySelector('.lookbook-product-slide.active');
        if (activeModal !== null) {
          activeModal.classList.remove('active');
          fullCollection.classList.remove('hide');
          window.scrollTo({
            top: currentScroll,
            behavior: 'smooth'
          });
          document.querySelector('.collection-wrapper').classList.add('hide');
          document.querySelector('.lookbook-v2-grid').classList.remove('hidden');
        }
      });
    });
  }
  var lookbookCollections = document.querySelectorAll('.lookbook-collection');
  if (lookbookCollections.length) {
    lookbookCollections.forEach(function (lookbookCollection) {
      lookbookCollection.addEventListener('click', function (e) {
        e.preventDefault();
        var lookbookContent = document.querySelector('.lookbook-content');
        var lookbookHeader = document.querySelector('.lookbook-header');
        if (lookbookContent) {
          lookbookContent.style.display = 'flex';
        }
        if (lookbookHeader) {
          lookbookHeader.style.display = 'none';
        }
      });
    });
  }
};
initLookbookV2();

// To run JS in customizer and see the result instantly (without page reload/save) just add init function below
onShopifySectionLoad(function () {
  initHotspotsTooltips();
  initCarouselSectionSliders();
  initLookbookV2();
});
function refreshLoyaltyLion() {
  if (window.loyaltylion) window.loyaltylion && window.loyaltylion.ui.refresh();
}
document.addEventListener('cart:rendered', refreshLoyaltyLion);

/* Account page points display */

var initLoyaltyPointsValueDisplay = function initLoyaltyPointsValueDisplay() {
  var pointsValueElement = document.querySelector('[data-lion-points-value]');
  var pointsElement = document.querySelector('[data-lion-points-account]');
  if (!pointsValueElement || !pointsElement) return;
  var valuePerPoints = pointsValueElement.dataset.lionPointsValue;
  if (!valuePerPoints) return;
  var currencyCode = Shopify.currency.active || 'GBP';
  var locale = Shopify != undefined ? "".concat(Shopify.locale, "-").concat(Shopify.country) || 'en-GB' : 'en-GB';
  var formatCurrency = function formatCurrency(value) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode
    }).format(value);
  };
  var config = {
    characterData: true,
    subtree: true,
    childList: true
  };
  var observer = new MutationObserver(function (mutationsList, observer) {
    var _iterator = _createForOfIteratorHelper(mutationsList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;
        if (mutation.type === 'characterData') {
          if (pointsElement.textContent.trim() !== '' && !isNaN(pointsElement.textContent.trim())) {
            var points = parseInt(pointsElement.textContent.trim());
            var value = points / valuePerPoints;
            pointsValueElement.textContent = formatCurrency(value);
            observer.disconnect();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  observer.observe(pointsElement, config);
};
initLoyaltyPointsValueDisplay();

//horrible jquery for the product card slides which should only work on desktop

document.addEventListener("DOMContentLoaded", function () {
  var sliders = document.querySelectorAll('.js-flickity-product-slider');
  if (sliders.length === 0) return;
  sliders.forEach(function (slider) {
    var flkty = slider.flickityInstance;
    function checkWidth() {
      if (window.innerWidth < 990) {
        if (flkty) {
          flkty.destroy();
          slider.flickityInstance = null;
        }
      }
    }
    checkWidth();
    window.addEventListener('resize', checkWidth);
  });
});
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth >= 990) return;
  document.querySelectorAll(".js-flickity-product-slider").forEach(function (slider) {
    var viewport = slider.querySelector(".flickity-viewport");
    if (!viewport) return;
    viewport.addEventListener("touchstart", function (e) {
      return e.stopImmediatePropagation();
    }, {
      passive: true
    });
  });
});
document.addEventListener('click', function (e) {
  var flickityBtn = e.target.closest('.flickity-button');
  if (!flickityBtn) return;
  e.preventDefault();
  e.stopPropagation();
});
/******/ })()
;